// A counterparty's documents, as the upload queue speaks of them (useAttachmentUploads.js): the
// queue's word is an attachment, a counterparty's is a document. Used where a file uploads at
// once - the profile - and where it waits for the counterparty to exist - the form that adds one
// (TX-US-0037).

import {
  confirmCounterpartyDocumentUpload,
  requestCounterpartyDocumentUpload,
} from '../../api.js';
import { STATES } from '../../deliveries/attachments/uploads.js';
import { contentTypeOf, validateCounterpartyFile } from './files.js';

export const DOCUMENTS_API = {
  request: async (counterpartyId, file) => {
    const contract = await requestCounterpartyDocumentUpload(
      counterpartyId, file, contentTypeOf(file),
    );
    return { ...contract, attachment: { attachment_id: contract.document.document_id } };
  },
  confirm: confirmCounterpartyDocumentUpload,
  validate: validateCounterpartyFile,
};

// What a file in the queue says of itself. `waiting` is for a queue that is not being drained
// yet: on the form that adds a counterparty a file waits for the save, not for its turn.
export const stateLabel = (state, waiting = 'Waiting') => ({
  [STATES.queued]: waiting,
  [STATES.uploading]: 'Uploading…',
  [STATES.done]: 'Uploaded',
  [STATES.failed]: 'Failed',
}[state]);
